import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatMarkdownRichText } from '../../../utils/formatRichText';

const SeoSubectExaplainerCTAMobile = ({ data }) => {
  if (!data) return null;

  const { title, card } = data;
  if (!card) return null;

  const { title: cardTitle, body = '' } = card;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        px: '16px',
        boxSizing: 'border-box',
        backgroundColor: '#F3F6F6',
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          boxSizing: 'border-box',
          py: '8px',
        }}
      >
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#162F3B',
            borderRadius: '32px',
            boxSizing: 'border-box',
            p: '32px 24px',
            boxShadow: '0px 12px 24px -4px rgba(22, 47, 59, 0.08)',
            zIndex: 2,
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '2rem',
              lineHeight: '2.25rem',
              letterSpacing: '-0.04em',
              color: '#FFFFFF',
              textAlign: 'center',
              px: '8px',
              whiteSpace: 'pre-line',
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            width: '100%',
            backgroundColor: '#FFFFFF',
            borderRadius: '28px',
            boxSizing: 'border-box',
            p: '24px 20px 28px',
            boxShadow: '0px 12px 24px -4px rgba(22, 47, 59, 0.08)',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
            zIndex: 1,
          }}
        >
          <Typography
            component="h3"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '1.5rem',
              lineHeight: '1.875rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              whiteSpace: 'pre-line',
            }}
          >
            {cardTitle}
          </Typography>

          <Typography
            component="div"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '1rem',
              lineHeight: '1.5rem',
              letterSpacing: '-0.002em',
              color: '#162F3B',
              whiteSpace: 'pre-line',
              '& p': {
                m: 0,
                mb: '1em',
              },
              '& p:last-of-type': {
                mb: 0,
              },
              '& ul': {
                m: 0,
                pl: '18px',
              },
              '& li': {
                mb: '0.5em',
              },
            }}
            dangerouslySetInnerHTML={{ __html: formatMarkdownRichText(body) }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SeoSubectExaplainerCTAMobile;
